(function () {
    'use strict';

    function contactAccountManager(sessionDataService, mailRequestDataService, notifyService) {
        return {
            restrict: 'E',
            scope: {
                mode: '@'
            },
            templateUrl: 'common/directives/templates/contactAccountManager.html',
            link: function (scope, element, attrs) {
                scope.assignedAccountManagers = [];
                scope.entityId = '';
                sessionDataService.loadSession().then(function (sessionData) {
                    scope.assignedAccountManagers = sessionData.AssignedAccountManagers;
                    scope.entityId = sessionData.EntityId;
                });

                scope.contactAccountManager = function (accountManagerId) {
                    mailRequestDataService.contactAccountManager({
                        'EntityId': scope.entityId,
                        'AccountManagerId': accountManagerId
                    }).then(function (data) {
                        notifyService.notify('Your contact request was successfully sent.');
                    });
                }

                scope.contactAllAccountManagers = function () {
                    mailRequestDataService.contactAllAccountManagers({
                        'EntityId': scope.entityId
                    }).then(function (data) {
                        notifyService.notify('Your request for help was successfully sent.');
                    });
                }
            }
        };
    }

    contactAccountManager.$inject = ['sessionDataService', 'mailRequestDataService', 'notifyService'];

    angular.module('ecap.common').directive('contactAccountManager', contactAccountManager);
})();